import { NavbarLogo } from '../auth/navbar/NavbarLogo';
import { Aside } from '../layouts';

export default function AuthNavbarSkeleton() {
  return (
    <Aside className="auth__navbar">
      <header className="header header-sticky !z-[6] bg-accent">
        <NavbarLogo />
      </header>

      <div className="grid gap-4 divide-y divide-white/20 px-4 py-6">
        <div className="h-9 w-full rounded-[50px] bg-white/20" />

        <div className="grid gap-4 pt-5">
          {Array.from({ length: 4 }).map((_, idx) => {
            return (
              <div
                key={idx}
                className="h-9 w-full rounded-[50px] bg-white/20"
              ></div>
            );
          })}
        </div>

        <div className="grid gap-4 pt-5">
          {Array.from({ length: 3 }).map((_, idx) => {
            return (
              <div
                key={idx}
                className="h-9 w-full rounded-[50px] bg-white/20"
              ></div>
            );
          })}
        </div>
      </div>
    </Aside>
  );
}
